export default {
  custom_option: 'Personalizzato',
  zero_option: 'Nessuna mancia',
};
